import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import Header from '../../../components/header/Header';
import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import ButtonNetwork from '../../../utils/network-connect/ButtonNetwork';
import { showNotificationDialog } from '../../../utils';

/**
 * 図16-1 パスワード変更画面
 */
const ChangePasswordScreen = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { changePassword } = useFujiAuth();

    /**
     * パスワード変更の実行
     *
     * @param {Object} params
     */
    const onFinish = ({ oldPassword, newPassword }: { oldPassword: string; newPassword: string }) => {
        //ローディングを表示
        setIsLoading(true);
        changePassword(oldPassword, newPassword, ({ isSuccessed, message }: { isSuccessed: boolean; message: any }) => {
            //ローディングを非表示
            setIsLoading(false);
            if (isSuccessed) {
                //変更完成のメッセンジを表示
                showNotificationDialog(
                    'success',
                    'change-password-success',
                    t('notification.title'),
                    t('notification.change-password-success'),
                );
                // 図8-1へ遷移
                navigate('/profile');
            } else if (message.name.includes('NotAuthorizedException')) {
                // MSG.10-E4 現在のパスワード不一致エラー
                showNotificationDialog(
                    'failed',
                    'change-password-failed',
                    t('notification.title'),
                    t('error-message.user-info.incorrect-password'),
                );
            } else if (message.message.includes('Network error')) {
                showNotificationDialog('error', '', t('notification.title'), t('error-message.server-error'));
            } else {
                // MSG.10-E5 パスワード更新失敗エラー
                showNotificationDialog(
                    'failed',
                    'change-password-failed',
                    t('notification.title'),
                    t('error-message.user-info.change-info-failed'),
                );
            }
        });
    };

    const onFinishFailed = () => {};
    return (
        <React.Fragment>
            {isLoading && <CenterLoading overFooter={true} />}
            <Header title={t('header.change-password')} />
            <div className={`content-footer-container scrollable ${styles.changePassContainer}`}>
                <div className={styles.changePassContent}>
                    <div className={styles.title}>
                        <p>{t('user-info.change-password')}</p>
                        <p>{t('user-info.enter-below')}</p>
                    </div>
                    <Form
                        className={styles.changePassForm}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                    >
                        <Form.Item
                            name="oldPassword"
                            rules={[
                                {
                                    required: true,
                                    message: t('validate.enter-current-password') ?? '',
                                },
                            ]}
                        >
                            <Input.Password
                                style={{ borderRadius: 4, height: 50 }}
                                className={styles.inputCustom}
                                placeholder={t('form.current-password') ?? ''}
                                type="password"
                                allowClear
                                maxLength={30}
                            />
                        </Form.Item>
                        <Form.Item
                            name="newPassword"
                            rules={[
                                {
                                    min: 8,
                                    message: t('validate.password-8ormore') ?? '',
                                },
                                {
                                    pattern:
                                        // eslint-disable-next-line no-useless-escape
                                        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9=+^$*.\[\]{}()?@#%&/\\,><':;|_~"!`-]/,
                                    message: t('validate.capital-number') ?? '',
                                },
                                {
                                    required: true,
                                    message: t('validate.password') ?? '',
                                },
                            ]}
                        >
                            <Input.Password
                                style={{ borderRadius: 4, height: 50 }}
                                className={styles.inputCustom}
                                placeholder={t('form.new-password') ?? ''}
                                size="large"
                                type="password"
                                allowClear
                                maxLength={30}
                            />
                        </Form.Item>
                        <Form.Item
                            name="confirm"
                            dependencies={['password']}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(t('validate.password-not-match') ?? ''));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                style={{ borderRadius: 4, height: 50 }}
                                className={styles.inputCustom}
                                placeholder={t('form.new-password-confirm') ?? ''}
                                size="large"
                                allowClear
                                maxLength={30}
                            />
                        </Form.Item>
                        <p style={{ fontSize: 12.5, marginBottom: 20 }}>{t('password.requirement')}</p>
                        <Form.Item>
                            <div className={styles.btnSubmit}>
                                <ButtonNetwork title={t('button.change')} />
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ChangePasswordScreen;
